/**
 * 公共方法
 */

/**
 * 动态引入script
 * @param src script资源地址
 * @returns Promise
 */
export const loadScript = (src: string) => {
  return new window.Promise((resolve) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = src;
    script.onload = () => resolve(true);
    document.head.appendChild(script);
  });
};

/**
 * 获取共享cookie的根域名
 * @returns 共享cookie的根域名
 */
export const getRootDomain = () => {
  const hostname = window.location.hostname;
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname; // ip
  } else {
    return hostname.split('.').slice(1).join('.');
  }
};

/**
 * 白名单域名列表
 * 只有白名单域名才接入arms、上报埋点
 */
const whiteListHost = [
  '.ovopark.com',
  '.wandianzhang.com',
  '.wistore.net',
  '.opretail.com',
  '.ihonto.com',
  '.visionmiracle.cn',
  '.aiotcdp.com',
  '.sps-cn.cn',
  '.ecovacs.cn',
  '.emenotec.com',
  '.nitrouk.com',
  '.sign-in-global.us',
  '.peoplecounter.tech',
  '.eatacsens.tech',
  '.nexshopai.com',
];
/** 是否在白名单域名 */
export const isInWhiteListHost = () => {
  return whiteListHost.some((host) => window.location.hostname.includes(host));
};
